import {
  PiggyBank, DollarSign, Target, TrendingUp,
  Building2, Hammer, Code, HeartPulse, ShoppingBag, UtensilsCrossed,
  Briefcase, Globe, Factory, Users, Palette,
  ShieldCheck, ScanLine, Map, BookOpen, Calculator,
  FolderOpen, MessageSquare
} from 'lucide-react';

export const fmt = (v) => {
  const n = typeof v === 'number' && !isNaN(v) ? v : (typeof v === 'string' ? parseFloat(v) : 0);
  return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(isNaN(n) ? 0 : n);
};

export const API_URL = process.env.REACT_APP_BACKEND_URL;

export const gradeConfig = {
  excellent: { color: 'text-emerald-600 dark:text-emerald-400', bg: 'bg-emerald-500', label: 'Excellent' },
  good: { color: 'text-blue-600 dark:text-blue-400', bg: 'bg-blue-500', label: 'Good' },
  fair: { color: 'text-amber-600 dark:text-amber-400', bg: 'bg-amber-500', label: 'Fair' },
  needs_attention: { color: 'text-orange-600 dark:text-orange-400', bg: 'bg-orange-500', label: 'Needs Attention' },
  critical: { color: 'text-rose-600 dark:text-rose-400', bg: 'bg-rose-500', label: 'Critical' },
};

export const categoryIcons = { tax_planning: PiggyBank, cash_flow: DollarSign, expense_optimization: Target, revenue_growth: TrendingUp };
export const categoryLabels = { tax_planning: 'Tax Planning', cash_flow: 'Cash Flow', expense_optimization: 'Expense Optimization', revenue_growth: 'Revenue Growth' };
export const categoryColors = {
  tax_planning: 'border-violet-200 dark:border-violet-800 bg-violet-50/50 dark:bg-violet-900/10',
  cash_flow: 'border-blue-200 dark:border-blue-800 bg-blue-50/50 dark:bg-blue-900/10',
  expense_optimization: 'border-amber-200 dark:border-amber-800 bg-amber-50/50 dark:bg-amber-900/10',
  revenue_growth: 'border-emerald-200 dark:border-emerald-800 bg-emerald-50/50 dark:bg-emerald-900/10',
};
export const categoryIconColors = {
  tax_planning: 'text-violet-600 dark:text-violet-400 bg-violet-100 dark:bg-violet-900/30',
  cash_flow: 'text-blue-600 dark:text-blue-400 bg-blue-100 dark:bg-blue-900/30',
  expense_optimization: 'text-amber-600 dark:text-amber-400 bg-amber-100 dark:bg-amber-900/30',
  revenue_growth: 'text-emerald-600 dark:text-emerald-400 bg-emerald-100 dark:bg-emerald-900/30',
};

export const industryIcons = {
  real_estate: Building2, construction: Hammer, tech_saas: Code, medical: HeartPulse,
  retail: ShoppingBag, restaurant: UtensilsCrossed, professional_services: Briefcase,
  ecommerce: Globe, manufacturing: Factory, consulting: Users, creative: Palette, other: Building2,
};

export const playbookCategoryColors = {
  depreciation_assets: { border: 'border-blue-200 dark:border-blue-800', bg: 'bg-blue-50 dark:bg-blue-900/10', text: 'text-blue-600 dark:text-blue-400', badge: 'bg-blue-100 text-blue-700 dark:bg-blue-900/40 dark:text-blue-400' },
  entity_income: { border: 'border-emerald-200 dark:border-emerald-800', bg: 'bg-emerald-50 dark:bg-emerald-900/10', text: 'text-emerald-600 dark:text-emerald-400', badge: 'bg-emerald-100 text-emerald-700 dark:bg-emerald-900/40 dark:text-emerald-400' },
  credits: { border: 'border-violet-200 dark:border-violet-800', bg: 'bg-violet-50 dark:bg-violet-900/10', text: 'text-violet-600 dark:text-violet-400', badge: 'bg-violet-100 text-violet-700 dark:bg-violet-900/40 dark:text-violet-400' },
  retirement_savings: { border: 'border-amber-200 dark:border-amber-800', bg: 'bg-amber-50 dark:bg-amber-900/10', text: 'text-amber-600 dark:text-amber-400', badge: 'bg-amber-100 text-amber-700 dark:bg-amber-900/40 dark:text-amber-400' },
  advanced_wealth: { border: 'border-rose-200 dark:border-rose-800', bg: 'bg-rose-50 dark:bg-rose-900/10', text: 'text-rose-600 dark:text-rose-400', badge: 'bg-rose-100 text-rose-700 dark:bg-rose-900/40 dark:text-rose-400' },
};

export const playbookCategoryLabels = {
  depreciation_assets: 'Depreciation & Assets', entity_income: 'Entity & Income', credits: 'Tax Credits',
  retirement_savings: 'Retirement & Savings', advanced_wealth: 'Advanced / Wealth',
};

export const complexityConfig = {
  simple: { label: 'Simple', color: 'bg-emerald-100 text-emerald-700 dark:bg-emerald-900/30 dark:text-emerald-400' },
  moderate: { label: 'Moderate', color: 'bg-amber-100 text-amber-700 dark:bg-amber-900/30 dark:text-amber-400' },
  advanced: { label: 'Advanced', color: 'bg-rose-100 text-rose-700 dark:bg-rose-900/30 dark:text-rose-400' },
};

export const TABS = [
  { id: 'overview', label: 'Overview', icon: ShieldCheck },
  { id: 'scanner', label: 'Document Scanner', icon: ScanLine },
  { id: 'taxmapper', label: 'Tax Mapper', icon: Map },
  { id: 'playbook', label: 'Tax Playbook', icon: BookOpen },
  { id: 'simulator', label: 'Tax Simulator', icon: Calculator },
  { id: 'savedplans', label: 'Saved Plans', icon: FolderOpen },
  { id: 'chat', label: 'Ask CFO Buck', icon: MessageSquare },
  { id: 'saved', label: 'Saved Chats', icon: MessageSquare },
];
